import Navbar from "@/components/landing/Navbar";
import Intro from "@/components/landing/Intro";
import Hero from "@/components/landing/Hero";
import Manifesto from "@/components/landing/Manifesto";
import WhatIsSkill from "@/components/landing/WhatIsSkill";
import Timeline from "@/components/landing/Timeline";
import SubmissionRules from "@/components/landing/SubmissionRules";
import JudgingCriteria from "@/components/landing/JudgingCriteria";
import Prizes from "@/components/landing/Prizes";
import Footer from "@/components/landing/Footer";

export default function Landing() {
  return (
    <div className="relative min-h-screen bg-[#050505] text-white" style={{ overflowX: "clip" }} data-testid="landing-page">
      {/* Background layers */}
      <div className="pointer-events-none fixed inset-0 grid-bg opacity-40 [mask-image:radial-gradient(ellipse_at_center,black_20%,transparent_80%)]" />
      <div className="pointer-events-none fixed inset-0 radial-fade" />

      <Navbar />
      <main className="relative z-10">
        <Intro />
        <Hero />
        <Manifesto />
        <WhatIsSkill />
        <Timeline />
        <SubmissionRules />
        <JudgingCriteria />
        <Prizes />
      </main>
      <Footer />
    </div>
  );
}
